/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';

import { emailAccessToken, putAccessToken } from '../../utils/api';

import { SuccessModal } from '../layouts/successModal';
import { EmailAddressModal } from './email-address';
import { DynamicModal } from '../layouts/dynamicModal';

import { VerifyCodeModel } from './verify-code';

import * as constants from '../../utils/constant';

import {
  SUCCESS,
  OK,
  EMAIL_ADDRESS_SAVED,
  NEW_EMAIL_ADDRESS_SAVED,
} from '../../utils/constant';

import { sharedLibrary } from '../../shared-library.config';

import { EMAIL_VERIFICATION_FLOW } from '../../types/online-forms.types';

export function EmailVerification({
  confirmEmail,
  setConfirmEmail,
  handleEditContactClose,
  openEditContact,
  setopenPhoneNumber,
  // setCpStatus,

  setShowPaperlessAlert,
  showPaperlessAlert,

  setAlertModalPreSelectedValue,
  setOldEmail,
  oldEmail,
  email,
  setEmail,
  handleCloseSuccess,
  contactData,
  contactDataLoading,
  getContactDetails,
  handleAlertModalOkBtn,
  showDiffEmailBtn,
  allContactNumberValue,
  setNewEmailAdded,
  newEmailAdded,
  openEmailAddress,
  setopenEmailAddress,
}: EMAIL_VERIFICATION_FLOW) {
  const [apiFailure, setApiFailure] = useState<boolean>(false);

  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [updateContactLoading, setUpdateContactLoading] =
    useState<boolean>(false);

  const config = sharedLibrary.getConfig();
  const highmarkURL = config.HIGHMARK_API_URL;
  const contactInfoURL = `${highmarkURL}/digital/v1/members/contact-information/contacts`;

  const [reSendModal, setReSendModal] = useState<boolean>(false);
  const [verifyCodeError, setverifyCodeError] = useState<boolean>(false);
  const [reSendCodeError, setreSendCodeError] = useState<boolean>(false);

  const [sendCodeLoading, setSendCodeLoading] = useState<boolean>(false);
  const [verifyApiLoading, setVerifyApiLoading] = useState<boolean>(false);

  const [newEmailConfirmModal, setNewEmailConfirmModal] =
    useState<boolean>(false);
  const [verifyCodeModel, setVerifyCodeModel] = useState<boolean>(false);

  const groupNumber = contactData[0]?.groupNumber
    ? contactData[0]?.groupNumber
    : localStorage.getItem('groupNumber');

  const sendEmailConfirmationURL = `${highmarkURL}/digital/v1/members/contact-information/sendEmail?emailAddress=${email}&groupNumber=${groupNumber}`;

  const handleConfirmationClose = () => {
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const setOpenSuccessModal = () => {
    setOpenSuccess(true);
  };

  const sendEmailConfirmationCode = () => {
    setSendCodeLoading(true);
    emailAccessToken(sendEmailConfirmationURL, '').then((result: any) => {
      if (result?.status === 200) {
        setSendCodeLoading(false);
        setVerifyCodeModel(true);
      }
      if ([400, 401, 500].includes(result?.status)) {
        setSendCodeLoading(false);
        setApiFailure(true);
        // setVerifyCodeModel(true);
        //  setSendCodeLoading(false);
      }
    });
  };

  const handleSendCodeClick = () => {
    sendEmailConfirmationCode();
    // setVerifyCodeModel(true);
  };

  const handleDifferentEmail = () => {
    setverifyCodeError(false);
    setNewEmailConfirmModal(true);
  };

  const handleDifferentEmailClose = () => {
    setNewEmailConfirmModal(false);
  };

  const handleClose = () => {
    setOpenSuccess(false);
    setNewEmailAdded(false);
    if (handleCloseSuccess !== undefined) handleCloseSuccess();
  };

  const handleSendCodeClose = () => {
    setVerifyCodeModel(false);
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const handleResendCode = () => {
    let sendCount = localStorage.getItem('sendCount') as any;
    sendCount = Math.floor(Number(sendCount === null ? 0 : sendCount));

    if (sendCount < 2) {
      localStorage.setItem('sendCount', sendCount + 1);
      setSendCodeLoading(true);
      emailAccessToken(sendEmailConfirmationURL).then((result: any) => {
        if (result?.status === 200) {
          setReSendModal(true);
          setSendCodeLoading(false);
        }
        if ([400, 401, 500].includes(result?.status)) {
          // setApiFailure(true);

          setReSendModal(true);
          setSendCodeLoading(false);
        }
      });
    } else {
      // setverifyCodeError(true);
      setNewEmailConfirmModal(false);
      setopenEmailAddress(false);
      setverifyCodeError(false);
      setConfirmEmail(false);
      setReSendModal(false);
      setVerifyCodeModel(false);
      setreSendCodeError(true);
      localStorage.removeItem('sendCount');
    }
  };

  const handleVerifyCodeEror = () => {
    setverifyCodeError(true);
    setReSendModal(false);
    setVerifyCodeModel(false);
  };

  const handleResendCodeClose = () => {
    setReSendModal(false);
    setVerifyCodeModel(false);
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const handleverifyCodeErrorClose = () => {
    setverifyCodeError(false);
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };
  const handleReSendCodeErrorClose = () => {
    setreSendCodeError(false);
    setNewEmailConfirmModal(false);
    setopenEmailAddress(false);
    setverifyCodeError(false);
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const handlePhoneClick = () => {
    setopenPhoneNumber(true);
  };

  const handleEmail = () => {
    setopenEmailAddress(true);
    // setEmail('');
    setConfirmEmail(false);
    if (handleEditContactClose !== undefined) handleEditContactClose();
  };

  const handleNewEmail = () => {
    setNewEmailConfirmModal(false);
    setConfirmEmail(false);
    setEmail('');
    handleEmail();
  };

  const handleEmailClose = () => {
    setopenEmailAddress(false);

    if (oldEmail) setEmail(oldEmail);
    if (handleEditContactClose !== undefined) handleEditContactClose();
    // handleEditContactClose();
  };

  const setApiFailureModal = () => {
    setApiFailure(true);
  };

  const handleAlertModalCancleBtn = () => {
    setShowPaperlessAlert(false);
    setAlertModalPreSelectedValue({
      key: '',
      value: '',
    });
  };

  const closeAPIFailureModal = () => {
    setApiFailure(false);
  };

  const verifyCode = (confirmationCode: any) => {
    const verifyCodeURL = `${highmarkURL}/digital/v1/members/contact-information/verifyEmail?emailCode=${confirmationCode}`;

    setVerifyApiLoading(true);
    emailAccessToken(verifyCodeURL, '').then((result: any) => {
      if (result?.status === 200) {
        setVerifyApiLoading(false);
        setReSendModal(false);
        setverifyCodeError(false);
        handleSendCodeClose();
        setOpenSuccess(true);
        getContactDetails(contactInfoURL, '');
      }
      if ([400, 401, 500].includes(result?.status)) {
        if (result?.status === 400) {
          handleSendCodeClose();
          setReSendModal(false);
          setverifyCodeError(true);
        } else {
          setApiFailure(true);
        }
        setVerifyApiLoading(false);
      }
    });
  };

  const updateEmailAddress = () => {
    const updateObj = {
      memberDetail: {
        umi: contactData[0]?.umi,
        pin: contactData[0]?.pin,
        firstName: contactData[0]?.firstName,
        middleName: contactData[0]?.middleName,
        lastName: contactData[0]?.lastName,
        birthDate: contactData[0]?.birthDate,
        gender: contactData[0]?.gender,
        ethnicity: contactData[0]?.ethnicity,
        groupNumber: contactData[0]?.groupNumber
          ? contactData[0]?.groupNumber
          : localStorage.getItem('groupNumber'),
        bpdId: contactData[0]?.bpdId,
        addressData: contactData[0]?.addressData,
      },
      contactPoints: [
        {
          type: 'Email',
          use: 'Member Supplied',
          value: email,
        },
        {
          type: 'Phone',
          use: 'Home',
          value: allContactNumberValue?.homePhone,
        },
        {
          type: 'Phone',
          use: 'Work',
          value: allContactNumberValue?.workPhone,
        },
        {
          type: 'Text',
          use: 'Mobile',
          value: allContactNumberValue?.textPhone,
        },
      ],
    };
    if (email) {
      setUpdateContactLoading(true);
      putAccessToken(contactInfoURL, updateObj).then((result: any) => {
        setUpdateContactLoading(false);
        if (result?.memberContactsResponse) {
          setNewEmailAdded(true);
          getContactDetails(contactInfoURL);
          handleEmailClose();
          setOldEmail(email);
          setConfirmEmail(true);
        }
        if (result.errMsg) {
          setApiFailure(true);
        }
      });
    }
  };

  return (
    <>
      <SuccessModal
        open={openSuccess}
        onClose={handleClose}
        heading={SUCCESS}
        description={
          newEmailAdded ? NEW_EMAIL_ADDRESS_SAVED : EMAIL_ADDRESS_SAVED
        }
        btnText={OK}
      />

      {openEditContact && (
        <DynamicModal
          open={openEditContact}
          onClose={handleEditContactClose}
          type="PREFERENCE_SELECT"
          heading={constants.ATTENTION}
          showDiffEmailBtn={showDiffEmailBtn}
          description={constants.PREFERENCE_SELECT_DESCRIPTION}
          description2={constants.API_FAILED_CONTENTSECOND}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          emailBtnText={constants.EMAIL_BTN_TEXT}
          phoneBtnText={constants.PHONE_BTN_TEXT}
          handlePhone={handlePhoneClick}
          handleEmail={handleEmail}
        />
      )}

      {showPaperlessAlert && (
        <DynamicModal
          open={showPaperlessAlert}
          type="GENERAL"
          heading={constants.ATTENTION}
          showDiffEmailBtn={showDiffEmailBtn}
          description={constants.ALERT_MODAL_TEXT}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          onClose={handleAlertModalCancleBtn}
          saveBtnHandler={handleAlertModalOkBtn}
        />
      )}

      {openEmailAddress && (
        <EmailAddressModal
          open={openEmailAddress}
          onClose={handleEmailClose}
          heading={constants.ATTENTION}
          description={constants.EMAIL_SELECT_DESCRIPTION}
          saveBtn={constants.CONFIRM_EMAIL_BTN}
          cancelBtn={constants.CANCEL_BTN}
          handleEditContactClose={handleEditContactClose}
          handleEmail={handleEmail}
          setApiFailure={setApiFailureModal}
          updateEmailAddress={updateEmailAddress}
          setConfirmEmail={setConfirmEmail}
          email={email}
          setEmail={setEmail}
          updateContactLoading={updateContactLoading}
        />
      )}

      {apiFailure && (
        <DynamicModal
          open={apiFailure}
          type="API_FAILED"
          heading={constants.API_FAILED_TITLE}
          description={constants.API_FAILED_CONTENT}
          description2={constants.API_FAILED_CONTENTSECOND}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          onClose={closeAPIFailureModal}
          saveBtnHandler={handleAlertModalOkBtn}
        />
      )}

      {confirmEmail && (
        <DynamicModal
          open={confirmEmail}
          onClose={handleConfirmationClose}
          type="EMAIL_VERIFY"
          heading={constants.ATTENTION}
          description={`We will send a confirmation code to <u>${email.toLowerCase()}</u> for verification.`}
          description2={constants.API_FAILED_CONTENTSECOND}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          showDiffEmailBtn={showDiffEmailBtn}
          emailBtnText={constants.EMAIL_CONFIRMATION_SENDBTN}
          phoneBtnText={constants.EMAIL_CONFIRMATION_DIFFBTN}
          handleEmail={handleSendCodeClick}
          handlePhone={handleDifferentEmail}
          apiLoading={sendCodeLoading}
          contactDataLoading={contactDataLoading}
        />
      )}

      {verifyCodeModel && (
        <VerifyCodeModel
          open={verifyCodeModel}
          onClose={handleSendCodeClose}
          heading={constants.ATTENTION}
          type="VERIFY_CODE"
          description={`We have sent a confirmation code to <u>${email.toLowerCase()}</u>. Please enter it below.`}
          verifyCodeBtn={constants.VERIFY_CODE}
          resendCodeBtn={constants.RESEND_CODE}
          cancelBtn={constants.CANCEL_BTN}
          handleResendCode={() => handleResendCode()}
          apiLoading={sendCodeLoading}
          verifyCode={verifyCode}
          verifyApiLoading={verifyApiLoading}
        />
      )}

      {newEmailConfirmModal && (
        <DynamicModal
          open={newEmailConfirmModal}
          onClose={handleDifferentEmailClose}
          type="NEW_EMAIL_CONFIRM"
          heading={constants.ATTENTION}
          showDiffEmailBtn={showDiffEmailBtn}
          description={constants.NEW_EMAIL_CONFIRM}
          description2={constants.CONTINUE_DESCRIPTION}
          saveBtn={constants.YES}
          cancelBtn={constants.NO}
          emailBtnText={constants.EMAIL_CONFIRMATION_SENDBTN}
          phoneBtnText={constants.EMAIL_CONFIRMATION_DIFFBTN}
          handleEmail={handleNewEmail}
          handlePhone={handleDifferentEmail}
          handleVerifyCodeEror={handleVerifyCodeEror}
        />
      )}

      {reSendModal && (
        <VerifyCodeModel
          open={reSendModal}
          onClose={handleResendCodeClose}
          heading={constants.ATTENTION}
          type="RESEND_CODE"
          description={`We have resent a confirmation code to <u>${email.toLowerCase()}</u>. Please enter it below to verify.`}
          description2={constants.RESEND_DESCRIPTION}
          verifyCodeBtn={constants.VERIFY_CODE}
          resendCodeBtn={constants.RESEND_CODE}
          cancelBtn={constants.CANCEL_BTN}
          handleResendCode={() => handleResendCode()}
          handleEditContactClose={handleEditContactClose}
          setOpenSuccess={setOpenSuccessModal}
          setApiFailure={setApiFailure}
          setverifyCodeError={setverifyCodeError}
          verifyCode={verifyCode}
          apiLoading={sendCodeLoading}
          verifyApiLoading={verifyApiLoading}
        />
      )}
      {verifyCodeError && (
        <DynamicModal
          open={verifyCodeError}
          onClose={handleverifyCodeErrorClose}
          type="VERIFY_ERROR"
          heading={constants.ATTENTION}
          description={`We couldn’t verify your address <u>${email.toLowerCase()}</u>. Please try again or use a different email.`}
          description2={constants.CONTINUE_DESCRIPTION}
          saveBtn={constants.YES}
          showDiffEmailBtn={showDiffEmailBtn}
          cancelBtn={constants.CANCEL_BTN}
          emailBtnText={constants.RESEND_CODE}
          phoneBtnText={constants.EMAIL_CONFIRMATION_DIFFBTN}
          handleEmail={() => handleResendCode()}
          handlePhone={handleDifferentEmail}
          apiLoading={sendCodeLoading}
          setApiFailure={setApiFailure}
        />
      )}

      {reSendCodeError && (
        <DynamicModal
          open={reSendCodeError}
          onClose={handleReSendCodeErrorClose}
          type="RESEND_ERROR"
          heading={constants.ATTENTION}
          description={constants.CUSTOMER_SUPPORT_DESCRIPTION}
          description2={constants.CONTINUE_DESCRIPTION}
          saveBtn={constants.OK}
          cancelBtn={constants.CANCEL_BTN}
          emailBtnText={constants.RESEND_CODE}
          phoneBtnText={constants.EMAIL_CONFIRMATION_DIFFBTN}
          handleEmail={handleNewEmail}
          handlePhone={handleDifferentEmail}
        />
      )}
    </>
  );
}
